import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"
import { StudentStoreSA } from "../../../react/students/StudentStoreSA"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum TruthAssets {
    WINDOW = "TruthWINDOW",

    LEADER = "TruthLEADER",
    FRIEND = "TruthFRIEND",
    USER = "TruthUSER",

    CLASS_BUBBLE = "TruthCLASS_BUBBLE",
    SPEECH_BUBBLE = "TruthSPEECH_BUBBLE",
    SPEECH_BUBBLE_LEADER = "TruthSPEECH_BUBBLE_LEADER",

    CHEW_CAN = "TruthCHEW_CAN",
    CIGARETTE = "TruthCIGARETTE",
    BEER = "TruthBEER",
    WEED = "TruthWEED",
    ECIG = "TruthECIG",

    // audio
    INTRO = "TruthINTRO",
    EXPLANATION = "TruthEXPLANATION",
    CHOOSE_FIRST_PLAYER = "TruthCHOOSE_FIRST_PLAYER",
    START_FIRST_QUESTION = "TruthSTART_FIRST_QUESTION",
    CHOOSE_TRUTH_OR_DARE = "TruthCHOOSE_TRUTH_OR_DARE",
    YOU_PICKED_DARE = "TruthYOU_PICKED_DARE",
    DARE_HANDSTAND = "TruthDARE_HANDSTAND",
    DARE_HATS = "TruthDARE_HATS",
    DARE_KISS = "TruthDARE_KISS",
    NEXT_QUESTION = "TruthNEXT_QUESTION",
    FRIENDS_TURN_TO_PICK_TRUTH_OR_DARE = "TruthFRIENDS_TURN_TO_PICK_TRUTH_OR_DARE",
    FRIEND_WANTS_TRUTH = "TruthFRIEND_WANTS_TRUTH",
    CLICK_NEXT = "TruthCLICK_NEXT",
    OUTRO = "TruthONTRO",
    TRUTH = "TruthTRUTH",
    DARE = "TruthDARE",
    KIDS_LAUGHING = "TruthKIDS_LAUGHING",

    QUESTION = "TruthQUESTION",
    RAISE_HANDS = "TruthRAISE_HANDS",
    QUESTION_PICKED_TRUTH = "TruthQUESTION_PICKED_TRUTH",
    QUESTION_ANSWER = "TruthQUESTION_ANSWER",
    QUESTION_OVERESTIMATE = "TruthQUESTION_OVERESTIMATE",
    QUESTION_UNDERESTIMATE = "TruthQUESTION_UNDERESTIMATE",
    QUESTION_CORRECT = "TruthQUESTION_CORRECT",
}

export enum TruthClassAssets {
    CLASS = "TruthCLASS",
    CLASS_ONE_HAND_A = "TruthCLASS_ONE_HAND_A",
    CLASS_ONE_HAND_B = "TruthCLASS_ONE_HAND_B",
    CLASS_ONE_HAND_C = "TruthCLASS_ONE_HAND_C",
    CLASS_HAND_STANDS = "TruthCLASS_HAND_STANDS",
    CLASS_KISSING = "TruthCLASS_KISSING",
    CLASS_SILLY_HATS = "TruthCLASS_SILLY_HATS",
    CLASS_TWO_HANDS_A = "TruthCLASS_TWO_HANDS_A",
    CLASS_TWO_HANDS_B = "TruthCLASS_TWO_HANDS_B",
    CLASS_TWO_HANDS_C = "TruthCLASS_TWO_HANDS_C",
}

export function loadAssets(game: Phaser.Game) {

    const load = PhaserUtils.makeLoader(game, "truth-or-dare")

    load.image(TruthAssets.WINDOW, "window.png")

    load.image(TruthAssets.LEADER, CCUtils.genderifyFileName("leader.png"))
    load.image(TruthAssets.FRIEND, CCUtils.genderifyFileName("friend.png"))
    load.image(TruthAssets.USER, CCUtils.genderifyFileName("user.png"))

    load.image(TruthAssets.CLASS_BUBBLE, "class-bubble.png")
    load.image(TruthAssets.SPEECH_BUBBLE, "speech-bubble.png")
    load.image(TruthAssets.SPEECH_BUBBLE_LEADER, "speech-bubble-leader.png")

    load.image(TruthAssets.CHEW_CAN, "tobacco-circle.png")
    load.image(TruthAssets.CIGARETTE, "cigarette-circle.png")
    load.image(TruthAssets.BEER, "beer-circle.png")
    load.image(TruthAssets.WEED, "cigar-circle.png")
    load.image(TruthAssets.ECIG, "vape-circle.png")

    load.image(TruthClassAssets.CLASS, "class.png")
    load.image(TruthClassAssets.CLASS_ONE_HAND_A, "class-one-hand-a.png")
    load.image(TruthClassAssets.CLASS_ONE_HAND_B, "class-one-hand-b.png")
    load.image(TruthClassAssets.CLASS_ONE_HAND_C, "class-one-hand-c.png")
    load.image(TruthClassAssets.CLASS_HAND_STANDS, "class-hand-stands.png")
    load.image(TruthClassAssets.CLASS_KISSING, "class-kissing.png")
    load.image(TruthClassAssets.CLASS_SILLY_HATS, "class-silly-hats.png")
    load.image(TruthClassAssets.CLASS_TWO_HANDS_A, "class-two-hands-a.png")
    load.image(TruthClassAssets.CLASS_TWO_HANDS_B, "class-two-hands-b.png")
    load.image(TruthClassAssets.CLASS_TWO_HANDS_C, "class-two-hands-c.png")

    load.audio(TruthAssets.INTRO, "truth-or-dare-n-intro.mp3", true)
    load.audio(TruthAssets.EXPLANATION, "truth-or-dare-n1.mp3", true)
    load.audio(TruthAssets.CHOOSE_FIRST_PLAYER, "truth-or-dare-n2.mp3", true)
    load.audio(TruthAssets.START_FIRST_QUESTION, "truth-or-dare-n3.mp3")
    load.audio(TruthAssets.CHOOSE_TRUTH_OR_DARE, "truth-or-dare-n4.mp3", true) // Dups: 19, 35
    load.audio(TruthAssets.YOU_PICKED_DARE, "truth-or-dare-n10.mp3") // Dups: 26, 42
    load.audio(TruthAssets.DARE_HANDSTAND, "truth-or-dare-n10-handstand.mp3")
    load.audio(TruthAssets.DARE_HATS, "truth-or-dare-n10-hats.mp3")
    load.audio(TruthAssets.DARE_KISS, "truth-or-dare-n10-kiss.mp3")
    load.audio(TruthAssets.NEXT_QUESTION, "truth-or-dare-n11.mp3")
    load.audio(TruthAssets.FRIENDS_TURN_TO_PICK_TRUTH_OR_DARE, "truth-or-dare-n12.mp3", true) // Dups: 27, 43
    load.audio(TruthAssets.FRIEND_WANTS_TRUTH, "truth-or-dare-n13.mp3", true) // Dups: 28, 44
    load.audio(TruthAssets.CLICK_NEXT, "truth-or-dare-n50.mp3")
    load.audio(TruthAssets.OUTRO, "truth-or-dare-n-outro.mp3")
    load.audio(TruthAssets.TRUTH, "truth.mp3")
    load.audio(TruthAssets.DARE, "dare.mp3")
    load.audio(TruthAssets.KIDS_LAUGHING, "kids-laughing.mp3")

    const trackNumbers = {
        1: 5,
        2: 14,
        3: 21,
        4: 29,
        5: 37,
        6: 45
    }

    for (let x = 1; x < 7; x++) {
        let trackNum = trackNumbers[x]
        const friend = x % 2 === 0
        const truthName = `truth-or-dare-n${trackNum}.mp3`
        const gender = StudentStoreSA.instance.currentGender()
        load.audio(TruthAssets.QUESTION + x, `truth-or-dare-${gender}-n${x}-1.mp3`)
        load.audio(TruthAssets.RAISE_HANDS + x, `truth-or-dare-${gender}-n${x}-2.mp3`)
        load.audio(TruthAssets.QUESTION_PICKED_TRUTH + x, friend ? CCUtils.genderifyFileName(truthName) : truthName)
        trackNum++
        if (trackNum === 30) {
            trackNum++
        }
        load.audio(TruthAssets.QUESTION_ANSWER + x, `truth-or-dare-n${trackNum}.mp3`)
        trackNum++
        load.audio(TruthAssets.QUESTION_OVERESTIMATE + x, `truth-or-dare-n${trackNum}.mp3`)
        trackNum++
        load.audio(TruthAssets.QUESTION_UNDERESTIMATE + x, `truth-or-dare-n${trackNum}.mp3`)
        trackNum++
        load.audio(TruthAssets.QUESTION_CORRECT + x, `truth-or-dare-n${trackNum}.mp3`)
    }

    // What is 20, 36 used for? dare, truth?
    // 30 is missing
}
